import React, { FC } from 'react';

import { defineMessages } from 'react-intl';

import { useISIntl } from 'src/i18n';
import UserModel from 'src/models/UserModel';
import { useTrackPaymentsViewedEvent } from 'src/payments/hooks/useTrackPaymentsViewedEvent';
import { PaymentEventComponent } from 'src/payments/types';
import { getPaymentEventSource } from 'src/payments/utils';

const messages = defineMessages({
  paymentsPaused: {
    id: 'paymentsDashboard.paymentsPaused',
    defaultMessage:
      'More info needed to verify your Stripe account. Until then, payments and payouts are paused.'
  },
  paymentsResolve: {
    id: 'paymentsDashboard.resolve',
    defaultMessage: 'Resolve'
  }
});

export const PaymentsDashboardRestricted: FC = () => {
  const { ft } = useISIntl();

  const paymentsViewedMeta = {
    source: getPaymentEventSource(),
    component: PaymentEventComponent.tileRestricted
  };

  useTrackPaymentsViewedEvent(paymentsViewedMeta, UserModel.getInstance().events);

  return (
    <div id="tailwind" data-testid="PaymentsDashboardRestricted">
      <div className="flex flex-col w-screen h-fit mt-6 md:mt-20 justify-center gap-10 items-center">
        <p className="text-center gap-8 max-w-xl text-3xl">{ft(messages.paymentsPaused)}</p>
        <a
          href="https://dashboard.stripe.com/account/status/"
          target="_blank"
          className="bg-orange-is px-5 py-4 border-none text-white rounded-xl font-bold text-2xl">
          {ft(messages.paymentsResolve)}
        </a>
      </div>
    </div>
  );
};
